import { taskOrIssueENUM } from "@mctypes/global.types";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import React, { useState } from "react";
import { Checkbox, EditSaveAbort, VSpace } from "../../../../components/";
import { setShowSuccessMessageThunk } from "../../../../global/globalSlice";
import { useAppDispatch } from "../../../../hooks";
import { ToastMessagesEnums } from "../../../../mc-shared/sharedConstants";
import { ISSUE_COLUMN_LABELS } from "../issueConstants";

const DisabledIssueColumns: React.FC<{
  board: IIssueBoardApi;
  updateBoards: (disabledColumns: string[]) => void;
  isEditable: boolean;
  editMode?: boolean;
  editCb?: (bool: boolean) => void;
  columnsTobeDisabled?: string[];
  taskOrIssue?: taskOrIssueENUM;
}> = ({ board, updateBoards, isEditable, editMode, editCb, columnsTobeDisabled, taskOrIssue = "ISSUE" }) => {
  const dispatch = useAppDispatch();

  let disabledColumnColTexts;
  if (taskOrIssue === "TASK") {
    disabledColumnColTexts = board.disabledColumnsTasks?.map((col) => {
      return ISSUE_COLUMN_LABELS[col] || col;
    });
  } else {
    disabledColumnColTexts = board.disabledColumns.map((col) => {
      return ISSUE_COLUMN_LABELS[col];
    });
  }

  const [editedColumns, setEditedColumns] = useState(taskOrIssue === "ISSUE" ? board.disabledColumns : board.disabledColumnsTasks);

  const save = async () => {
    if (JSON.stringify(editedColumns) !== JSON.stringify(taskOrIssue === "ISSUE" ? board.disabledColumns : board.disabledColumnsTasks)) {
      dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
      await updateBoards(editedColumns);
    }
    editCb(false);
  };

  return (
    <div className="mb-2">
      <div className="d-flex flex-column">
        {editMode === false && (
          <div>
            {disabledColumnColTexts?.map((col, index) => (
              <div key={index}>{col}</div>
            ))}
          </div>
        )}
        {editMode && (
          <EditDisableColumns
            editedColumns={editedColumns}
            setEditedColumns={setEditedColumns}
            columnsTobeDisabled={columnsTobeDisabled}
            taskOrIssue={taskOrIssue}
          />
        )}
        <VSpace />
        <EditSaveAbort editable={isEditable} big saveCb={save} editMode={editMode} editModeCb={editCb} />
      </div>
    </div>
  );
};

export default DisabledIssueColumns;

const EditDisableColumns: React.FC<{
  editedColumns: string[];
  setEditedColumns: any;
  columnsTobeDisabled?: string[];
  taskOrIssue?: taskOrIssueENUM;
}> = ({ editedColumns, setEditedColumns, columnsTobeDisabled, taskOrIssue }) => {
  const _setColumn = (dataField: string) => {
    const index = editedColumns?.indexOf(dataField);
    let _editedColumns = [...editedColumns];
    if (index === -1) {
      _editedColumns.push(dataField);
    } else {
      _editedColumns.splice(index, 1);
    }
    setEditedColumns(_editedColumns);
  };

  const columns =
    taskOrIssue === "TASK"
      ? columnsTobeDisabled.map((dataField) => ({
          dataField,
          text: ISSUE_COLUMN_LABELS[dataField] || dataField, // fallback to field name if no label
        }))
      : Object.entries(ISSUE_COLUMN_LABELS)
          .filter(([dataField]) => columnsTobeDisabled.includes(dataField))
          .map(([dataField, text]) => ({ dataField, text }));

  return (
    <div>
      {columns.map((c) => (
        <div key={c.dataField}>
          <VSpace />
          <Checkbox
            mode="cross"
            text={c.text}
            disabled={false}
            isChecked={editedColumns.includes(c.dataField)}
            setChecked={() => _setColumn(c.dataField)}
            color="#dc3545"
          />
        </div>
      ))}
    </div>
  );
};
